// Fixed-step loops that end at an anchor time: the national mosaic steps by
// 5 minutes, the satellite clock by the sector's scan cadence.

export function snapToStep(ms, stepMs) {
  if (!Number.isFinite(ms) || !(stepMs > 0)) return NaN;
  return Math.floor(ms / stepMs) * stepMs;
}

// Play loops `frameCount` steps ending at the anchor, then wraps.
export function loopStartMs(anchorMs, frameCount, stepMs) {
  const count = Math.max(1, frameCount | 0);
  return snapToStep(anchorMs, stepMs) - (count - 1) * stepMs;
}

export function stepLoop(currentMs, anchorMs, frameCount, stepMs) {
  const anchor = snapToStep(anchorMs, stepMs);
  const start = loopStartMs(anchor, frameCount, stepMs);
  const next = snapToStep(currentMs, stepMs) + stepMs;
  return next > anchor ? start : next;
}

export function loopTimes(anchorMs, frameCount, stepMs) {
  const count = Math.max(1, frameCount | 0);
  const start = loopStartMs(anchorMs, count, stepMs);
  return Array.from({ length: count }, (_, i) => start + i * stepMs);
}

export function formatLoopSpan(minutes) {
  const total = Math.max(0, Math.round(minutes));
  if (total < 60) return `${total} min`;
  if (total % 60 === 0) return total === 60 ? "1 hr" : `${total / 60} hr`;
  return `${Math.floor(total / 60)}h ${total % 60}m`;
}

// "12 · 1 hr" for twelve 5-minute frames, "30 · 30 min" for thirty Meso scans.
export function formatLoopLabel(frameCount, stepMs) {
  const count = Math.max(1, frameCount | 0);
  return `${count} · ${formatLoopSpan((count * stepMs) / 60000)}`;
}
